import GetSchedulerByReferentsRequestModelBase from '../_generated/modelBases/get-scheduler-by-referents-request-model-base';

export default class GetSchedulerByReferentsRequestModel extends GetSchedulerByReferentsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
